export default __webpack_public_path__ + "static/media/shape1.3914b0bd.png";